import React, { useState, useEffect,useContext } from 'react'
import { useNavigate } from 'react-router-dom'
import Swal from 'sweetalert2';
import { Passaggio } from "../App"
import "./OrdiniClasse.css"

const OrdiniClasse = () => {
    const { url } = useContext(Passaggio);
    const link = useNavigate()

    const [classi, setClassi] = useState([]);
    const [classe, setClasse] = useState("");
    const [ordini, setOrdini] = useState([]);

    // raggruppa ordini per locale
    const ordiniPerLocale = ordini.reduce((acc, ordine) => {

        if (!acc[ordine.localeNome]) {
            acc[ordine.localeNome] = []
        }

        acc[ordine.localeNome].push(ordine)

        return acc

    }, {})

    let totaleClasse = 0

    // carica classi
    useEffect(() => {

        fetch(url+"/classi",
            {
                method: 'GET',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                    'Authorization': "Bearer " + sessionStorage.getItem("token")
                }
            }
        )
            .then(res => res.json())
            .then(data => {

                if (data.risultato == "ko" || data.risultato == undefined) {

                    Swal.fire({
                        title: 'Login fallito. Riprova.',
                        icon: 'warning',
                        timer: 1500,
                        showConfirmButton: false
                    });

                    link("/")

                } else {

                    setClassi(data.rows)

                }

            })
            .catch(err => console.error(err));

    }, []);

    // carica ordini
    useEffect(() => {

        if (!classe) return;

        fetch(url+`/ordini/classe/${classe}`)
            .then(res => res.json())
            .then(data => setOrdini(data))
            .catch(err => console.error(err));

    }, [classe]);

    return (

        <div className="ordiniClassePage">

            <div className="log">

                <div className="contenitoreOrdiniClasse">

                    <div className="headingsContainer">

                        <h1>Ordini per Classe</h1>
                        <h2>Visualizza gli ordini effettuati</h2>

                        <div className="selezioneClasse">

                            <select
                                value={classe}
                                onChange={(e) => setClasse(e.target.value)}
                            >

                                <option value="">Seleziona classe</option>

                                {classi.map((c, i) => (
                                    <option key={i} value={c.classe}>
                                        {c.classe}
                                    </option>
                                ))}

                            </select>

                        </div>

                    </div>

                    <div className="ordiniWrapper">

                        {Object.keys(ordiniPerLocale).length === 0 && classe && (
                            <div className="nessunOrdine">
                                Nessun ordine per questa classe
                            </div>
                        )}

                        {Object.entries(ordiniPerLocale).map(([locale, listaOrdini]) => {

                            let totaleLocale = 0

                            return (

                                <div key={locale} className="localeBlocco">

                                    <div className="localeHeader">
                                        <span className="localeNome">{locale}</span>
                                    </div>

                                    {listaOrdini.map(o => {

                                        const totale = o.quantita * o.prezzoUnitario

                                        totaleLocale += totale
                                        totaleClasse += totale

                                        return (

                                            <div key={o.ordineID} className="ordineCard">

                                                <div className="ordineProdotto">
                                                    {o.prodottoDesc}
                                                </div>

                                                <div className="ordineInfo">
                                                    {o.user} - {o.classe}
                                                </div>

                                                <div className="ordineInfo">
                                                    {o.quantita} x €{o.prezzoUnitario}
                                                </div>

                                                <div className="ordineTotale">
                                                    Totale €{totale.toFixed(2)}
                                                </div>

                                            </div>

                                        )

                                    })}

                                    <div className="totaleLocale">
                                        Totale: €{totaleLocale.toFixed(2)}
                                    </div>

                                </div>

                            )

                        })}

                    </div>

                    <div className="totaleClasse">
                        Totale Classe: €{totaleClasse.toFixed(2)}
                    </div>

                </div>

            </div>

        </div>

    );

}

export default OrdiniClasse